import Actions from '../action'

const initialState = {
    isLoading: false,
    error: false,
    tagsList: [],
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.GET_ALL_TAGS: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_ALL_TAGS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                tagsList: action.data,
                error: false
            };
        }
        case Actions.GET_ALL_TAGS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }
        default:
            return state;
    }

};